export const MY_TEAM = 'my-team';
export const JOIN_TEAM = 'join-team';
export const CREATE_TEAM = 'create-team';
export const SHOW_SCHOOL_CLASS_CODE = 'show-school-class-code';
export const SHOW_TEAM_CODE = 'show-teams-code';
export const JOIN_CLASS = 'join-class';
export const AUTH_JOIN_CLASS = 'auth-join-class';
export const MY_CLASS = 'my-class';
